import { render, staticRenderFns } from "./Calling.vue?vue&type=template&id=3b7895ba&scoped=true"
import script from "./Calling.vue?vue&type=script&lang=js"
export * from "./Calling.vue?vue&type=script&lang=js"
import style0 from "./Calling.vue?vue&type=style&index=0&id=3b7895ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7895ba",
  null
  
)

export default component.exports